export interface ILocalStorage {
  getItemOrDefault<T = any>(key: string, defaultValue: T): T;
  getItem<T = any>(key: string): T | null;
  setItem<T = any>(key: string, value: T): void;
  removeItem(key: string): void;
}

export function LocalStorage(namespace: string): ILocalStorage {
  return {
    getItemOrDefault<T = any>(key: string, defaultValue: T): T {
      const value = this.getItem<T>(key);
      if (typeof value !== "undefined" && value !== null) {
        return value;
      }
      return defaultValue;
    },
    getItem<T = any>(key: string): T | null {
      const item = window.localStorage.getItem(`${namespace}:${key}`);
      return item ? JSON.parse(item) : null;
    },
    setItem<T = any>(key: string, value: T): void {
      window.localStorage.setItem(`${namespace}:${key}`, JSON.stringify(value));
    },
    removeItem(key: string): void {
      window.localStorage.removeItem(`${namespace}:${key}`);
    },
  };
}
